import { Injectable } from '@angular/core';
import { ServerErrorCodes } from '../../../assets/data/server-error-codes.enum';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  constructor() {}

  getErrorMessage(serverMessage: any) {
    serverMessage = serverMessage?.error ?? serverMessage;

    // Handle object-shaped API errors (e.g. { errorCode, message, details })
    if (typeof serverMessage === 'object' && serverMessage !== null) {
      const msg =
        serverMessage.message ?? serverMessage.Message;
      const details =
        serverMessage.details ?? serverMessage.Details;
      if (typeof msg === 'string' && msg.trim().length > 0) {
        const text = details && typeof details === 'string' && details.trim().length > 0
          ? `${msg.trim()}. ${details.trim()}`
          : msg.trim();
        return text;
      }
      const code =
        serverMessage.errorCode ?? serverMessage.ErrorCode;
      if (typeof code === 'string' && code.trim().length > 0) {
        const errorCodes = Object.keys(
          ServerErrorCodes
        ) as (keyof typeof ServerErrorCodes)[];
        const normalizedCode = code.replace(/[\s:]+/g, '').toUpperCase();
        for (const key of errorCodes) {
          if (key === normalizedCode) {
            return ServerErrorCodes[key];
          }
        }
      }
    }

    if (typeof serverMessage === 'string') {
      let errorHtml = '';
      const errorCodes = Object.keys(
        ServerErrorCodes
      ) as (keyof typeof ServerErrorCodes)[];
      let errorMessageCodes = this.getErrorMessageCodes(serverMessage);
      for (let errorMessageCode of errorMessageCodes) {
        errorMessageCode = errorMessageCode
          .replace(/[\s:]+/g, '')
          .toUpperCase();
        for (const errorCode of errorCodes) {
          if (errorMessageCode.includes(errorCode)) {
            errorHtml = errorHtml + `<li>${ServerErrorCodes[errorCode]}</li>`;
          }
        }
      }

      if (errorHtml.length > 0) {
        errorHtml = `<ol>${errorHtml}</ol>`;
      }

      if (errorHtml === '') {
        return ServerErrorCodes.GENERIC_ERROR;
      }

      return errorHtml;
    }

    return 'Προέκυψε ένα απροσδιόριστο σφάλμα. Παρακαλώ επικοινωνήστε με τον διαχειριστή της εφαρμογής.';
  }

  private getErrorMessageCodes(serverMessage: string) {
    let errorMessageCodes: string[] = [];
    if (serverMessage.indexOf('|')) {
      errorMessageCodes = serverMessage.split('|');
    } else {
      errorMessageCodes.push('serverMessage');
    }
    return errorMessageCodes;
  }
}
